module.exports = __webpack_public_path__ + "158ba4b746859971a82cbcce3674a9ee.png";